/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Price_NegotiableInputs */

const cs_form_price_negotiable = /** @type {(inputs: Form_Price_NegotiableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena k jednání`)
};

const en_form_price_negotiable = /** @type {(inputs: Form_Price_NegotiableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price negotiable`)
};

/**
* | output |
* | --- |
* | "Price negotiable" |
*
* @param {Form_Price_NegotiableInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_price_negotiable = /** @type {((inputs?: Form_Price_NegotiableInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Price_NegotiableInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_price_negotiable(inputs)
	return cs_form_price_negotiable(inputs)
});